<template>
    <transition appear name="fade">
    <page-main ref="page" tag="main" class="wrapper--page page--discover">

        <section class="page-featured has-clip">
            <h1 class="title title--dash">
                Amazing lives fuelled by <strong>rewarding</strong> careers
            </h1>
    
            <PageTabs 
                :key="restored"
                :slides="slides"
            />
        </section>

        <div class="has-clip">
            <PageCtas
                :styled="true"
            />
        </div>

        <SlideLines />

        <PageFooter />
    
    </page-main>
    </transition>
</template>

<script>
import gsap from 'gsap'
import { mapGetters } from 'vuex'
import { discoverConfig } from '@/router/module/shared'
import { browser } from '@/mixins/main'

import PageTabs from './PageTabs'
import PageCtas from './PageCtas'
import SlideLines from '../Slide/SlideLines'
import PageFooter from '../PageFooter.vue'

import { metaBeforeEnter } from '@/helpers/helperSlides'
const { titles, alias } = discoverConfig

export default {
    name: 'DiscoverSlides',

    props: {
        source: String, 
        poster: String,
    },

    components: {
        PageTabs,
        PageCtas,
        SlideLines,
        PageFooter,
    },

    mixins: [
        browser,
    ],

    data: () => ({
        transitionName: '',
        restored: 0,
        moduleType: 'discover',
    }),

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.transitionName = 'load'
            metaBeforeEnter.call(vm, alias, titles)
            gsap.set( document.body, {
                scrollTop: 0,
            })
        })
    },

    deactivated() {
        this.restored = 0
        this.$root.$off('slides-refresh')
    },

    activated() {
        // this.restored++
        this.$root.$on('slides-refresh', async () => {
            this.restored++
        })

        this.rootClass('rm', 'no-overflow')

        this.afterActivate()
    },

    methods: {
        afterActivate() {
            // this.focusables().add( this.$refs.page, `a, button:not([role=tab])` )
            // this.restorePageFocus('h1', 600)
        },
    },

    computed: {
        ...mapGetters({
            user: 'user',
            slides: 'discover/slides',
            stories: 'discover/stories'
        })
    },
}
</script>

<style lang="scss" scoped>
.page--discover {
    flex-basis: 100%;
    min-height: 100svh;
}
.page-featured {
    padding-top: 3rem;
    padding-inline: 20px;

    @media (width > 767px) {
        padding-top: 10rem;
    }
    @media (width > 991px) {
        padding-top: calc(7rem + 10vh);
    }
}
.page--discover .title {
    font-weight: 400;
    width: min(100% - 40px, 20ch);
    margin-inline: auto;
    text-align: center;

    strong {
        font-weight: 500
    }
}
</style>
